import React, { useState, useRef, useEffect } from 'react';
import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import './chatStayle.css'; 

const Chat = ({ isOpen, paraQuien,toggleChat}) => {
    
const [messages, setMessages] = useState([]);
  const [mensajeNuevo, setMensajeNuevo] = useState('');
  const messagesEndRef = useRef(null);



  
  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]); 

  useEffect(() => {
    if (isOpen) {
      conectar();
    }
  }, [isOpen,paraQuien]); 

  const buscar = {
    id: 0,
    deQuien: localStorage.getItem('email'),
    paraQuien: paraQuien,
    mensaje: "",
    conexion:"" 
  };

  const conectar = async () => {
    try {
      console.log("estre")
      let response =  await fetch(`https://sistemadesemapideploy.azurewebsites.net/api/Mensaje/Obtener`,
        {
          method: "POST",
          headers: {
            'Content-Type': 'application/json',
            'apiKey': localStorage.getItem("apiKey"),
          },
          body: JSON.stringify(buscar)
          
      }); 
      console.log("estoy g")
      console.log(response)
      if (response.ok) {
          let data = await response.json();
          
          let mensajes = data.map(mensaje => ({
            Code: mensaje.conexion,
            msg: mensaje.mensaje,
            remitente:mensaje.paraQuien
          }));
          console.log(data)
        
          
          setMessages(mensajes);
      } else {
        console.log("romi")
        console.log(response)
          console.error('Error al obtener mensaje');
      }
      
      const connection = new HubConnectionBuilder()
        .withUrl("https://sistemadesemapideploy.azurewebsites.net/chat") // Hacemos la conexión
        .configureLogging(LogLevel.Information)
        .build();

      await connection.start(); // Empezamos la conexión

      const deQuien = localStorage.getItem('email');
      
     console.log(deQuien)

     

      
     
      
      await connection.invoke("JoinSpesificChatRoom", deQuien, paraQuien); // Notificamos que estamos escuchando

      // Suscripción a eventos
      connection.on("JoinSpesificChatRoom", (msg, remitente ) => {
       
      });

      connection.on("ReceiveSpesificMessage", (msg, remitente) => {
        // Actualizar el estado de messages cuando se recibe un mensaje específico
        setMessages(prevMessages => [...prevMessages, { msg, remitente }]);

      });

      //setConnection(connection); // Guardamos la conexión
      
      

    } catch (error) {
      console.log('Error en la conexión:', error);
    }
  };

  const enviarMensaje = async () => {
   
    if (mensajeNuevo.trim() === '') return; // No enviar mensajes vacíos
    try {
      const registro = {
        id: 0,
        deQuien: localStorage.getItem('email'),
        paraQuien: paraQuien,
        mensaje: mensajeNuevo,
        conexion:"" 
      };

      await fetch(`https://sistemadesemapideploy.azurewebsites.net/api/Mensaje/Enviar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'apiKey': localStorage.getItem("apiKey"),
        },
        body: JSON.stringify(registro)
      });

      // Limpiar el campo de texto después de enviar el mensaje
      setMensajeNuevo('');

    } catch (error) {
      console.error('Error en la solicitud', error);
    }
  };

  return (
    <div className={`chat ${isOpen ? 'abierto' : 'cerrado'}`}>
      <div className="chat-header">
        <p className='Texto'>Chat con {paraQuien}</p>
        <button className="close-btn" onClick={toggleChat}>X</button>
      </div>
      <div className="chat-content">
        <div className="messages-container mb-3">
        {messages.length === 0 && (<div className="alert alert-primary" role="alert" >
                               No existen mensajes anteriores
                            </div>)}
          {messages.map((message, index) => (
            <div 
              className={`Texto ${message.remitente === localStorage.getItem("email") ? 'message-left' : 'message-right'}`} 
              key={index}
            >
              {message.msg}
            </div>
          ))}
          <div ref={messagesEndRef} /> 
        </div>
      </div>
      <div className="chat-input input-group">
  <input
    type="text"
    className="form-control"
    value={mensajeNuevo}
    onChange={(e) => setMensajeNuevo(e.target.value)}
    placeholder="Escribe un mensaje..."
  />
  <div className="input-group-append">
    <button className="btn btnColorPrincipal " onClick={enviarMensaje}>
      Enviar
    </button>
  </div>
</div>

    </div>
  );
  
}


export default Chat;
